import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { useDevice } from '../Device';
import { BaseTextField } from './BaseTextField/BaseTextField';
import { MobileTextField } from './MobileTextField';
import { useTextFieldMobileMode } from './TextFieldMobileModeContext';
export const TextField = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { enableMobileMode } = props, restProps = _object_without_properties(props, [
        "enableMobileMode"
    ]);
    const { isMobileDevice } = useDevice();
    const contextMobileMode = useTextFieldMobileMode();
    const resolvedMobileMode = enableMobileMode !== null && enableMobileMode !== void 0 ? enableMobileMode : contextMobileMode;
    const Component = resolvedMobileMode && isMobileDevice ? MobileTextField : BaseTextField;
    return /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread({}, restProps), {
        ref: ref
    }));
});
